@if (isTableRefreshed && filteredDs && filteredDs.data.length > 0) {
<div class="app-search-table">
  <app-table-data
    [pageSize]="pageSizeOptions"
    [dataSource]="filteredDs"
    [columns]="TABLE_COLUMNS"
    [tableConfig]="tableConfig"
    [localFilterConfig]="localFilterConfig"
    (onApplicationLinkClicked)="openApplication($event)"
  >
  </app-table-data>
</div>
}
